/**
 * index.tsx — Application entry point for Chanelle OS.
 *
 * Boot sequence:
 *   1. Import global styles (monday Vibe base + app overrides)
 *   2. Initialise the Widget Registry (all widget definitions)
 *   3. Mount the React app into #root
 */

import React from 'react';
import ReactDOM from 'react-dom/client';

// ── Global styles (order matters) ───────────────────────────────────────────
import 'monday-ui-style/dist/index.min.css';
import 'monday-ui-react-core/dist/main.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import './styles/global.css';

// ── Widget Registry bootstrap ────────────────────────────────────────────────
import { initializeWidgetRegistry } from './widget-framework/WidgetRegistry';
initializeWidgetRegistry();

// ── Root component ───────────────────────────────────────────────────────────
import { App } from './App';

// ── Mount ────────────────────────────────────────────────────────────────────
const container = document.getElementById('root');
if (!container) {
  throw new Error(
    '[Chanelle OS] Could not find #root element. Check public/index.html.'
  );
}

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
